import { Link } from "react-router-dom";
import { Phone, Clock, ShieldCheck, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import { scrollToId } from "@/components/Navbar";

const Footer = () => (
  <footer data-testid="footer-section" className="relative border-t border-white/10 bg-obsidian overflow-hidden">
    <span className="pointer-events-none select-none absolute -bottom-10 left-1/2 -translate-x-1/2 font-display font-black uppercase text-[22vw] leading-none text-outline opacity-25 whitespace-nowrap">
      Autoric
    </span>
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <Logo />
        <p className="mt-5 text-sm text-gray-500 leading-relaxed max-w-xs">
          Professional dash camera supply and hardwire installation. Concealed wiring, parking-mode security, mobile service.
        </p>
      </div>
      <div>
        <h4 className="font-mono text-[10px] uppercase tracking-[0.3em] text-sky-500/90 mb-5">Quick jump</h4>
        <nav className="grid grid-cols-2 gap-3">
          {["services", "process", "work", "pricing", "faq", "contact"].map((id) => (
            <button
              key={id}
              data-testid={`footer-link-${id}`}
              onClick={() => scrollToId(id)}
              className="text-left font-display font-bold uppercase tracking-widest text-sm text-gray-400 hover:text-sky-400 transition-colors"
            >
              {id}
            </button>
          ))}
        </nav>
      </div>
      <div className="space-y-4">
        <h4 className="font-mono text-[10px] uppercase tracking-[0.3em] text-sky-500/90 mb-5">Contact</h4>
        <a data-testid="footer-phone" href="tel:0415414296" className="flex items-center gap-3 text-gray-200 hover:text-sky-400 transition-colors font-display font-bold text-2xl">
          <Phone size={18} className="text-sky-500" /> 0415 414 296
        </a>
        <p className="flex items-center gap-3 text-sm text-gray-500">
          <Clock size={15} className="text-sky-500" /> Mon–Sat, 8am–6pm
        </p>
        <p className="flex items-center gap-3 text-sm text-gray-500">
          <MapPin size={15} className="text-sky-500" /> Servicing all Perth metro suburbs
        </p>
        <p className="flex items-center gap-3 text-sm text-gray-500">
          <ShieldCheck size={15} className="text-sky-500" /> 12-month workmanship warranty
        </p>
      </div>
    </div>
    <div className="relative border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gray-600">
          © 2026 Autoric. All rights reserved.
        </p>
        <Link data-testid="footer-admin-link" to="/admin" className="font-mono text-[10px] uppercase tracking-[0.25em] text-gray-600 hover:text-sky-400 transition-colors">
          Admin
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
